@import "../use-bootstrap-mixins.scss";

.skip_button {
  background-color: transparent;
  border: 2px solid $primary;
  border-radius: 14px;
  color: $primaryOnBackground !important;
  padding: 12px;
  display: block;
  font-size: 16px;
  margin: 0 auto;

  &:hover {
    cursor: pointer;
  }

  @include media-breakpoint-up(sm) {
    max-width: 370px;
  }

  @include media-breakpoint-up(lg) {
    position: inherit;
    max-width: 342px;
    margin: 0 auto;
    margin-top: 77px;
    display: block;
  }
}

.touchIcon {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 14px;
  margin-bottom: 12px;

  .span {
    font-size: 12px;
    color: #787878;
  }

  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.title {
  text-align: center;
  margin-top: 28px;
  width: 100%;
}

.responseRow {
  display: flex;
  flex-wrap: wrap;
  gap: 21px;
  justify-content: center;
}

.responseRow > * {
  flex: 0 0 calc(50% - 11px);

  @include media-breakpoint-up(lg) {
    flex: 0 0 calc(25% - 18px);
  }
}

.card {
  cursor: pointer;
  text-align: center;
  width: 100%;
}

.cardBody {
  background-color: #f5f5f5;
  position: relative;
  border-radius: 14px;
  height: 100%;
  padding: 14px;
  transition: all 0.4s;

  .name {
    margin: 0;
    font-size: 18px;
    transition: all 0.4s;
    display: flex;
    justify-content: center;
    align-items: center;

    .noAvailable {
      margin-left: 4px;
      background-color: $primary;
      height: 22px;
      width: 22px;
      display: block;
      color: #fff !important;
      border-radius: 12px;
      transition: all;
      line-height: 1.2 !important;
    }
  }

  .description {
    color: white;
    font-size: 12px;
    display: none;
    text-align: center;
    transition: all 0.4s;
  }

  .icon_container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s;
    @include media-breakpoint-up(lg) {
      height: 200px;
    }
  }

  .icon {
    max-height: 191px;
    max-width: 100%;
    transition: all 0.6s;
  }

  .button_container {
    position: absolute;
    width: calc(100% - 28px);
    bottom: 24px;
  }

  .continue_button {
    background-color: $primary;
    color: $textColorOnPrimary !important;
    border-radius: 14px;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid $primary;
    height: 29px;
    display: none;
    margin: 0 auto;
    transition: all 0.3s;

    &:hover {
      cursor: pointer;
    }

    @include media-breakpoint-up(lg) {
      display: block;
      max-width: 100%;
      padding: 0 12px;
    }
  }

  @include media-breakpoint-up(lg) {
    height: 321px;
    &:hover {
      background-color: $primary;

      .name {
        color: $textColorOnPrimary !important;

        .noAvailable {
          background-color: var(--rs-highlight) !important;
          color: $primary !important;
        }
      }

      .continue_button {
        border: 1px solid #fff;
      }

      .icon_container {
        height: 160px;
        margin-top: 0px;
        img {
          max-height: 160px;
        }
      }

      .description {
        display: block;
        margin-top: 1rem;
        font-size: 13px;
        color: $textColorOnPrimary !important;
      }
    }
  }
}
